import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderYearFilterModal = (data) => openPopupHelper({ popupName: popupNames.YEAR_FILTER_MODAL, data });
